export const CHANGE_RECORD = 'ChangeRecord';
export const CHANGE_CLIENT = 'ChangeClient';
export const CHANGE_CLIENT_FILES = 'ChangeClientFiles';
export const CHANGE_CLIENT_FILES_ADD = 'ChangeClientsFilesAdd';
export const CHANGE_CLIENT_FILES_DELETE = 'ChangeClientsFilesDelete';
export const CHAT_MESSAGE = 'ChatMessage';
export const MODIFIED = 'Modified';
